module.exports = __webpack_public_path__ + "img/catalog.ba6c7b3c.png";